import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
* {
    box-sizing: border-box;
    font-family: 'Opens Sans', sans-serif;
    
}
html, body{
    margin: 0;
    color: rgba(0,0,0,0.87);
    padding: 0;
    font-family: times-light, "Times New Roman", sans-serif;
    outline: 0;
    background-color: #fff;
    width: 100%;
   
    
}

.mobile{
    
    width:80%;
    height:auto;
    display:flex;
    flex-direction:column;
    text-align:center;
    
}

.custom-radio  {
  display:flex;
  flex-direction:column;
  justify-content: center;
  align-items:center;
  text-align:justify;
  
}
.custom-radio .ant-radio-wrapper {
  font-size: 18px;
}
.formItems{
    width:100%;
    
}

.formItems label {
  font-weight: bold;
}

.containerEmpreendimento {
    display: flex; 
    justify-content: center;
    flex-direction:column;
    align-items:center;
   
}
.selectEmpreendimento{
    
    width:100%
}
.checkBoxEmpreendimento{
     
    margin-top:20px
}


@media (max-width: 430px) {
   .mobile {
    width: 100% !important;
    align-items: center;
    justify-content: center;
    overflow-x: hidden;
  }

  .mobile .ant-card-head {
    width: 100%;
  }

  .mobile .ant-card-head-title {
    width: 100%;
    display: flex;
    justify-content: center;
    
    padding: 8px; /* ajuste o padding conforme necessário */
  }
  .formItems {
    width: 250px !important; 
  }
  .buttonForm {
    margin-top: 8%;
    margin-left: -65%;
  }
  .terceiroPassoStyle {
    display: flex; 
    justify-content: center;
    flex-direction: column;
    margin-top: 2%;
    width: 250px;
  }
  .custom-radio .ant-radio-wrapper {
    font-size: 16px;
  }
}

@media (min-width: 431px) and (max-width: 820px) {
  .mobile {
    width: 520px !important;
  }
}

@media (min-width: 821px) and (max-width: 1025px) {
  .mobile {
    /* Estilos para este intervalo de largura */
  }
}
@media (min-width: 1280px) {
  .mobile {
    width:100%
  }
}

`;
